module.exports = __webpack_public_path__ + "img/safe-fill.02adc71b.svg";